(function () {
  var PRESENTATIONAL_CHILD_ROLES = {
    button: true,
    checkbox: true,
    img: true,
    image: true,
    math: true,
    menuitemcheckbox: true,
    menuitemradio: true,
    option: true,
    progressbar: true,
    radio: true,
    scrollbar: true,
    separator: true,
    slider: true,
    switch: true,
    tab: true,
  };
  var INTERACTIVE_PRESENTATIONAL_ROLES = {
    button: true,
    checkbox: true,
    menuitemcheckbox: true,
    menuitemradio: true,
    option: true,
    radio: true,
    slider: true,
    switch: true,
    tab: true,
  };
  var watchedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;

  function forEachMatching(root, selector, callback) {
    if (!root) return;
    var type = root.nodeType;
    var isElement = type === Node.ELEMENT_NODE;
    var isQueryRoot =
      isElement || type === Node.DOCUMENT_NODE || type === Node.DOCUMENT_FRAGMENT_NODE || root === document;
    if (!isQueryRoot) return;

    if (isElement && root.matches && root.matches(selector)) callback(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(callback);
  }

  function classNameOf(el) {
    if (!el) return '';
    if (typeof el.className === 'string') return el.className;
    return el.getAttribute ? el.getAttribute('class') || '' : '';
  }

  function isChoiceInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    var type = (el.getAttribute('type') || '').toLowerCase();
    return type === 'radio' || type === 'checkbox';
  }

  function isKeyboardFocusable(el) {
    if (!el || el.nodeType !== 1 || el.hasAttribute('disabled')) return false;
    var tabindex = el.getAttribute('tabindex');
    if (tabindex === '-1') return false;
    var tag = el.tagName;
    if (tag === 'A') return el.hasAttribute('href');
    if (tag === 'BUTTON' || tag === 'SELECT' || tag === 'TEXTAREA' || tag === 'SUMMARY') return true;
    if (tag === 'INPUT') return (el.getAttribute('type') || '').toLowerCase() !== 'hidden';
    if (el.getAttribute('contenteditable') === 'true') return true;
    return tabindex !== null && Number(tabindex) >= 0;
  }

  function fixNestedInteractive(root) {
    forEachMatching(
      root,
      '.jdgm-rev-widg__summary-stars[role="img"], .jdgm-rev-widg__summary-stars[aria-label]',
      function (stars) {
        var parentControl = stars.closest('a, button, [role="button"], [role="link"]');
        if (!parentControl) return;

        var label = stars.getAttribute('aria-label');
        if (label && !parentControl.getAttribute('aria-label')) {
          parentControl.setAttribute('aria-label', label);
        }

        stars.removeAttribute('role');
        stars.removeAttribute('aria-label');
        stars.setAttribute('aria-hidden', 'true');
      }
    );

    forEachMatching(root, 'a a, button a, a button, button button', function (nested) {
      var wrapper = document.createElement('span');
      Array.from(nested.attributes).forEach(function (attr) {
        if (
          attr.name === 'href' ||
          attr.name === 'role' ||
          attr.name === 'tabindex' ||
          attr.name === 'target' ||
          attr.name.indexOf('aria-') === 0
        ) {
          return;
        }
        wrapper.setAttribute(attr.name, attr.value);
      });
      while (nested.firstChild) wrapper.appendChild(nested.firstChild);
      nested.replaceWith(wrapper);
    });
  }

  function fixProhibitedAria(root) {
    forEachMatching(root, '.star-rating-wrapper[aria-label]', function (el) {
      if (!el.getAttribute('role')) el.setAttribute('role', 'img');
    });

    forEachMatching(root, 'section[aria-label], section[aria-labelledby]', function (el) {
      if (!el.getAttribute('role')) el.setAttribute('role', 'region');
    });
  }

  function normalizedText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function visibleControlText(el) {
    var clone = el.cloneNode(true);
    clone.querySelectorAll('[aria-hidden="true"], .visually-hidden, .hidden, [hidden], script, style').forEach(function (node) {
      node.remove();
    });
    return normalizedText(clone.textContent);
  }

  function labelledByText(el) {
    var ids = (el.getAttribute('aria-labelledby') || '').split(/\s+/);
    var name = '';
    ids.forEach(function (id) {
      if (!id) return;
      var ref = document.getElementById(id);
      if (ref) name += ' ' + (ref.textContent || '');
    });
    return normalizedText(name);
  }

  function hasAccessibleName(el) {
    if (normalizedText(el.getAttribute('aria-label'))) return true;
    if (labelledByText(el)) return true;
    if (normalizedText(el.textContent)) return true;
    var named = false;
    el.querySelectorAll('img[alt], svg title').forEach(function (node) {
      var value = node.getAttribute('alt') || node.textContent;
      if (normalizedText(value)) named = true;
    });
    return named;
  }

  function nameContainsVisible(name, visible) {
    if (!visible) return true;
    return name.toLowerCase().indexOf(visible.toLowerCase()) !== -1;
  }

  function fixControlNames(root) {
    forEachMatching(root, '.swiper-button-next, .swiper-button-prev, .swiper-button-next-hide', function (el) {
      if (!normalizedText(el.getAttribute('aria-label'))) {
        el.setAttribute('aria-label', el.classList.contains('swiper-button-prev') ? 'Previous slide' : 'Next slide');
      }
      if (el.tagName !== 'BUTTON' && !el.getAttribute('role') && !focusableDescendants(el).length) {
        el.setAttribute('role', 'button');
      }
    });

    forEachMatching(root, 'a, button, [role="button"], [role="link"]', function (el) {
      var aria = normalizedText(el.getAttribute('aria-label'));
      var visible = visibleControlText(el);
      if (aria && !nameContainsVisible(aria, visible)) el.removeAttribute('aria-label');

      var labelled = labelledByText(el);
      if (el.hasAttribute('aria-labelledby') && labelled && !nameContainsVisible(labelled, visible)) {
        el.removeAttribute('aria-labelledby');
      }

      if (hasAccessibleName(el)) return;

      var label = labelForUnnamedControl(el);
      if (label) {
        el.setAttribute('aria-label', label);
        el.querySelectorAll('svg').forEach(function (svg) {
          if (!svg.getAttribute('aria-label')) svg.setAttribute('aria-hidden', 'true');
        });
        return;
      }

      if (el.tagName === 'A') {
        var image = el.querySelector('img');
        if (image && !normalizedText(image.getAttribute('alt'))) image.setAttribute('alt', 'Learn more');
        if (!hasAccessibleName(el)) el.setAttribute('aria-label', 'Learn more');
      }
    });
  }

  function focusableDescendants(el) {
    var found = [];
    if (!el.querySelectorAll) return found;
    el.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex], [contenteditable="true"]').forEach(
      function (node) {
        if (node !== el && isKeyboardFocusable(node) && !isChoiceInput(node)) found.push(node);
      }
    );
    return found;
  }

  function labelForUnnamedControl(el) {
    var className = classNameOf(el);
    var code = normalizedText(el.getAttribute('data-code'));
    if (code) return 'Copy code ' + code;
    if (/copy-btn|coupon-copy/i.test(className)) return 'Copy code';
    if (/close/i.test(className)) return 'Close';
    if (/unmute|mute/i.test(className)) return 'Unmute video';
    if (/prev/i.test(className)) return 'Previous';
    if (/next/i.test(className)) return 'Next';
    if (/popup/i.test(className) || el.hasAttribute('data-popup-open')) {
      var open = el.hasAttribute('data-popup-open') || el.getAttribute('aria-expanded') === 'true';
      return open ? 'Close popup' : 'Open popup';
    }
    return '';
  }

  function fixPresentationalFocus(root) {
    forEachMatching(root, 'div[role]', function (el) {
      var role = (el.getAttribute('role') || '').split(/\s+/)[0].toLowerCase();
      if (!PRESENTATIONAL_CHILD_ROLES[role]) return;
      var focusable = focusableDescendants(el);
      if (!focusable.length) return;

      if (isKeyboardFocusable(el) && INTERACTIVE_PRESENTATIONAL_ROLES[role]) {
        focusable.forEach(function (node) {
          node.setAttribute('tabindex', '-1');
        });
        return;
      }

      el.removeAttribute('role');
      if (el.hasAttribute('aria-label')) el.removeAttribute('aria-label');
      if (el.getAttribute('tabindex') === '0') el.removeAttribute('tabindex');
    });
  }

  var IFRAME_NAMING_ROLES = { application: true, document: true, img: true };
  var IFRAME_PRESENTATIONAL_ROLES = { generic: true, none: true, presentation: true };
  var IFRAME_UNSUPPORTED_ARIA = [
    'aria-activedescendant',
    'aria-autocomplete',
    'aria-braillelabel',
    'aria-brailleroledescription',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colindextext',
    'aria-colspan',
    'aria-expanded',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-required',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowindextext',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
  ];

  function iframeRole(frame) {
    return (frame.getAttribute('role') || '').split(/\s+/)[0].toLowerCase();
  }

  function fixIframeAria(frame) {
    var role = iframeRole(frame);
    if (IFRAME_PRESENTATIONAL_ROLES[role]) {
      frame.removeAttribute('role');
      role = '';
    }

    var allowName = !!IFRAME_NAMING_ROLES[role];
    IFRAME_UNSUPPORTED_ARIA.forEach(function (attr) {
      if (!frame.hasAttribute(attr)) return;
      if (allowName && (attr === 'aria-label' || attr === 'aria-labelledby' || attr === 'aria-braillelabel')) return;
      frame.removeAttribute(attr);
    });
  }

  function fixIframeTitles(root) {
    forEachMatching(root, 'iframe', function (frame) {
      fixIframeAria(frame);
      if (normalizedText(frame.getAttribute('title'))) return;
      var src = frame.getAttribute('src') || '';
      var title = 'Embedded content';
      if (src.indexOf('googletagmanager') !== -1) title = 'Google Tag Manager';
      else if (src.indexOf('youtube') !== -1 || src.indexOf('youtu.be') !== -1) title = 'YouTube video';
      else if (src.indexOf('vimeo') !== -1) title = 'Vimeo video';
      else if (src.indexOf('klaviyo') !== -1) title = 'Email signup';
      frame.setAttribute('title', title);
    });
  }

  function inLandmark(el) {
    return !!el.closest(
      'header, nav, main, footer, [role="banner"], [role="navigation"], [role="main"], [role="contentinfo"], [role="complementary"], [role="search"], [role="region"]'
    );
  }

  function fixLandmarks() {
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (!el || el.nodeType !== 1) return;
      var tag = el.tagName;
      if (
        tag === 'SCRIPT' ||
        tag === 'STYLE' ||
        tag === 'NOSCRIPT' ||
        tag === 'LINK' ||
        tag === 'TEMPLATE' ||
        tag === 'HEADER' ||
        tag === 'MAIN' ||
        tag === 'FOOTER' ||
        tag === 'NAV' ||
        tag === 'A' ||
        tag === 'BUTTON' ||
        tag === 'IFRAME'
      ) {
        return;
      }
      if (inLandmark(el) || el.getAttribute('role')) return;
      if (el.getAttribute('aria-hidden') === 'true' || el.hasAttribute('hidden')) return;
      if (!normalizedText(el.textContent)) return;
      el.setAttribute('role', 'region');
      if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
        var regionCount = document.querySelectorAll('[data-extra-region]').length + 1;
        el.setAttribute('data-extra-region', String(regionCount));
        el.setAttribute('aria-label', 'Additional content ' + regionCount);
      }
    });
  }

  function removeEmptyHeadings(root) {
    forEachMatching(root, 'h1, h2, h3, h4, h5, h6', function (heading) {
      if (heading.classList.contains('header__heading')) return;
      var text = normalizedText(heading.textContent);
      var namedImage = false;
      heading.querySelectorAll('img').forEach(function (img) {
        if (normalizedText(img.getAttribute('alt'))) namedImage = true;
      });
      if (text || namedImage) return;
      if (heading.querySelector('img, svg, canvas')) {
        if (!heading.querySelector('.visually-hidden')) {
          var span = document.createElement('span');
          span.className = 'visually-hidden';
          span.textContent = 'Section';
          heading.insertBefore(span, heading.firstChild);
        }
        return;
      }
      heading.remove();
    });
  }

  function visitShadows(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) applyAccessibilityFixes(el.shadowRoot);
    });
  }

  function applyAccessibilityFixes(root) {
    fixNestedInteractive(root);
    fixProhibitedAria(root);
    fixPresentationalFocus(root);
    fixControlNames(root);
    fixIframeTitles(root);
    removeEmptyHeadings(root);
    if (root === document || root === document.documentElement || root === document.body) fixLandmarks();
    visitShadows(root);
    if (root.nodeType === Node.DOCUMENT_FRAGMENT_NODE) watchRoot(root);
  }

  function scanAddedNode(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    var tag = node.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'META') return;
    applyAccessibilityFixes(node);
  }

  var pendingNodes = [];
  var scanScheduled = false;

  function flushPendingNodes() {
    scanScheduled = false;
    var nodes = pendingNodes;
    pendingNodes = [];
    for (var i = 0; i < nodes.length; i++) scanAddedNode(nodes[i]);
    fixLandmarks();
  }

  function queueRecords(records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === Node.ELEMENT_NODE) pendingNodes.push(added[j]);
      }
    }
    if (!scanScheduled && pendingNodes.length) {
      scanScheduled = true;
      requestAnimationFrame(flushPendingNodes);
    }
  }

  function onDomMutations(records) {
    queueRecords(records);
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      if (record.type !== 'attributes') continue;
      var target = record.target;
      if (target && target.tagName === 'IFRAME') fixIframeTitles(target);
    }
  }

  function watchRoot(root) {
    if (!root || !root.nodeType || (watchedRoots && watchedRoots.has(root))) return;
    if (watchedRoots) watchedRoots.add(root);
    new MutationObserver(onDomMutations).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role'].concat(IFRAME_UNSUPPORTED_ARIA),
    });
  }

  if (Element.prototype.attachShadow) {
    var nativeAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (init) {
      var shadow = nativeAttachShadow.call(this, init);
      watchRoot(shadow);
      applyAccessibilityFixes(shadow);
      return shadow;
    };
  }

  watchRoot(document.documentElement);
  applyAccessibilityFixes(document);
})();
